<template>
  <fragment>
    <h2 :class="`${selector}__heading heading`" v-html="title"></h2>
    <p :class="classObject()+ '' + `${selector}__text text`" v-html="text"></p>
    <a v-if="link" :href="'https://'+link" :class="`${selector}__link text`">{{link}}</a>
  </fragment>
</template>

<script>
export default {
  name: 'blockHeading',
  props: {
    selector: String,
    title: String,
    text: String,
    link: String,
  },
  methods: {
    classObject() {
      return {
        'is-before-link': this.link,
      };
    },
  },
};
</script>

<style scoped lang="scss">
@import '../../../sass/setup.scss';

.heading {
  margin-right: auto;
  margin-left: auto;
  font-family: $f-neutraBook;
  font-size: 26px;
  line-height: 30px;
  letter-spacing: 0.65px;
  text-transform: uppercase;
  text-align: center;

  @include up-tablet {
    font-size: 28px;
    line-height: 1.29;
    letter-spacing: 0.7px;
  }
}

.text {
  margin-right: auto;
  margin-left: auto;
  font-family: $f-bellReg;
  font-size: 16px;
  line-height: 1.25;
  letter-spacing: 0.12px;
  text-align: center;

  @include up-tablet {
    font-size: 20px;
    line-height: 24px;
    letter-spacing: 0.15px;
  }
}
</style>
